<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <modal-likes :targetItem="getModalLikesTarget" ref="modalLikes"/>
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_1on1_on.png" alt="">
            {{$t('oneOnTileType')}}
          </h1>
          <span class="info-right"></span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight flex-option">
          <template>
            <!-- 1on1item -->
            <div v-if ="!Object.values(getCurrent1on1s)[0]" class="ibox">
              <div class="ibox-title">{{$t('notFoundOneStr')}}</div>
            </div>
            <template v-for="(oneItem, index) in getOnes">
              <div :key="oneItem.id" v-if="Object.values(getCurrent1on1s)[0] && oneItem.one.contents" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
                <div class="ibox-title">
                  <div class="flex-box fl-between">
                    <h3 class="h3 font-bold">{{ reviewOf(oneItem.one.date) }}</h3>
                    <div id="partnerInfo" class="partnerinfo" v-if="oneItem.one.partner">
                      <user-icon-name :user-id="oneItem.one.partner" class-name="partner" />
                    </div>
                    <div><one-drop-down :item="oneItem.one" :id="oneItem.key"/></div>
                  </div>
                </div>
                <div class="ibox-content">
                  <!-- 1on1Component2 -->
                  <div v-for="count in checkContent1on1" :key="count.id" @click="onClickOneItem(oneItem.one, oneItem.key , count -1)" id="one-item2" class="ibox-child">
                    <div class="flex-box cursor">
                      <img class="one-icon" :src="'static/img/1on1/img0' + count + '.png'" alt="">
                      <div class="comment">
                        <div class="flex-box fl-between">
                          <h4 class="h3">{{contentTitle[count-1]}}</h4>
                          <div><a class="info-comment-detail" href="#">
                            <span class="isExistUnread">
                              <img class="info-icon" src="static/img/assets/comment.png">
                            </span>
                            <span v-bind:class="{ unread: get1on1UnreadCommentKeys('1on1s_'+ String(count-1), oneItem.key, oneItem.one.comments) }">{{ getCommentsByCommentIdsTargetType(oneItem.one.comments || {}, '1on1s_' + [count-1]).length }}</span>
                          </a>
                          <a class="info-comment-detail" href="#">
                            <img class="star" v-if="isLiked(oneItem.one.likes,count-1)" @click.stop="onClickStarLiked(oneItem.key,count-1)" :src="'static/img/assets/nice_on.png'">
                            <img class="star" v-else @click.stop="onClickStarNotLiked(oneItem.key,count-1)" :src="'static/img/assets/nice_off.png'">
                            <span class="like-counter" @click.stop="showModalLikes(oneItem.key, count-1)" v-if="!!oneItem.one && !!oneItem.one.likes && !!oneItem.one.likes[count-1]"><strong v-bind:class="{ unread: isUnreadLikeExist(oneItem.key, getUserId, oneItem.one.likes[count-1], count-1) }">{{ oneItem.one.likes[count-1] ? Object.keys(oneItem.one.likes[count-1]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                          </a>
                        </div>
                        </div>
                        <one-item :detailView="false" :item="oneItem.one.contents[count-1]" :itemType="String(count-1)"/>
                      </div>
                    </div>
                  </div>
                  <!-- /1on1Component2  -->

                  <div @click="onClickOneItem(oneItem.one, oneItem.key, 'memo')" id="one-item5" class="ibox-child one-child private-memo cursor">
                    <div class="flex-box cursor">
                      <img class="one-icon" src="static/img/1on1/img05.png" alt="">
                      <div class="comment">
                        <h4 class="h3">{{$t('memoContent1on1')}}</h4>
                        <one-item :detailView="false" :item="oneItem.one.memo" :itemType="'memo'"/>
                      </div>
                    </div>
                  </div>
                </div>
              <!-- /ibox-content -->
              </div>
            </template>
          <!-- /1on1item -->
          </template>

        </section>
      </article>

      <!-- DetailView -->
    <one-detail-view :targetOneItemKey="targetOneItemKey" :targetContent="targetContent" ref="oneDetailView" @close-detail-view="onClickCloseDetailView"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserIconName from '@/components/User/UserIconName'
import OneDropDown from '@/components/One/OneDropDown'
import OneItem from '@/components/One/OneItem'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import ModalLikes from '@/components/Comment/ModalLikes'
import OneDetailView from '@/components/DetailView/OneDetailView'
import { content1on1 } from '@/main'

export default {
  name: 'OneList',
  components: {
    UserIconName,
    OneDropDown,
    OneItem,
    ReadMore,
    OneDetailView,
    ModalLikes
  },
  data: function () {
    return {
      tag: 'progress',
      open: false,
      targetType: '',
      targetOneItem: {},
      targetOneItemKey: '',
      targetComments: {},
      targetContent: '',
      replyParent: {},
      oneCount: 30,
      propShowMore: false,
      propContentHeight: 0,
      content1on1: content1on1,
      modalTargetFeed: {}
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneList'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('ones/', [
      'getCurrent1on1s',
      'getIsReadLike'
    ]),
    ...mapGetters('comments/', [
      'getIsReadComment',
      'getCommentsByCommentIdsTargetType'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    contentTitle () {
      return {
        0: this.$t('firstContent1on1'),
        1: this.$t('secondContent1on1'),
        2: this.$t('thirdContent1on1'),
        3: this.$t('forthContent1on1')
      }
    },
    checkContent1on1 () {
      return Object.keys(content1on1.content1on1).length
    },
    getOnes () {
      const ones = this.getCurrent1on1s
      console.log('getcurrent', ones)
      // console.log('in getOnes', ones)
      let onesForShow = []
      for (let oneKey of Object.keys(ones)) {
        if (ones[oneKey] && ones[oneKey].contents) {
          if (ones[oneKey].date.indexOf('-') !== -1) {
            ones[oneKey].date = ones[oneKey].date.replace(/-/g, '/')
          }
          onesForShow.push({
            key: oneKey,
            one: ones[oneKey]
          })
        }
      }
      return onesForShow.reverse().slice(0, this.oneCount)
    },
    objectOfOnes () {
      let obj = {}
      Object.keys(this.getOnes).forEach(ones => {
        obj[this.getOnes[ones].key] = this.getOnes[ones].one
      })
      return obj
    },
    getModalLikesTarget () {
      return this.modalTargetFeed
    }
  },
  mounted: function () {
    console.log('content1on1::', content1on1)
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('ones/', {
      // VuexFireからのActionを読み込み
      setLikes: 'SET_ONES_LIKES',
      removeLikes: 'REMOVE_ONES_LIKES'
    }),
    reviewOf: function (date) {
      // console.log('reviewOf:', date)
      let ymd = (date || '').split('/')
      let dateFormatted = this.$t('noticeDateFormat')
        .replace('{$y}', (ymd[0] || '----'))
        .replace('{$m}', (ymd[1] || '--'))
        .replace('{$d}', (ymd[2] || '--'))
      return this.$t('retrospectiveStr').replace('{$date}', dateFormatted)
    },
    isLiked: function (likes, number) {
      if (!likes || !likes.hasOwnProperty(number)) {
        return false
      } else {
        return Object.keys(likes[number]).filter(x => x === this.getUserId).length !== 0
      }
    },
    onClickStarNotLiked: function (key, number) {
      this.setLikes({
        key: key,
        userId: this.getUserId,
        contentKey: number,
        targetUserId: this.getUserId
      })
    },
    onClickStarLiked: function (key, number) {
      this.removeLikes({
        key: key,
        userId: this.getUserId,
        contentKey: number,
        targetUserId: this.getUserId
      })
    },
    showModalLikes (key, number) {
      for (let likeOwner in this.objectOfOnes[key]['likes'][String(number)]) {
        if (!this.getIsReadLike(this.getUserId, key, likeOwner, number)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: '1on1s_' + String(number),
            targetOwner: this.getUserId,
            targetId: key,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      let targetlikes = {}
      targetlikes['likes'] = this.objectOfOnes[key]['likes'][String(number)]
      targetlikes['userId'] = this.objectOfOnes[key]['userId'] || this.getUserId
      targetlikes['userName'] = this.getUserInfoById(this.objectOfOnes[key]['userId'] || this.getUserId).userName
      targetlikes['contentText'] = this.objectOfOnes[key]['contents'][String(number)]
      targetlikes['createdAt'] = this.objectOfOnes[key]['date']
      targetlikes['itemType'] = '1on1'
      this.modalTargetFeed = targetlikes
      this.$refs.modalLikes.showModal()
    },
    isUnreadLikeExist (onesKey, OwnerId, likeOwners, number) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLike(OwnerId, onesKey, likeOwner, number)) {
          return true
        }
      }
      return false
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    onClickOneItem: function (oneItem, key, content) {
      // this.targetOneItem = !oneItem ? [] : oneItem
      console.log('onclick', oneItem, content, key)
      let type = '1on1s_' + content
      this.targetOneItemKey = key
      // console.log(this.targetOneItemKey)
      this.targetContent = content
      this.targetType = type
      for (let commentId in oneItem.comments) {
        if (!this.getIsReadComment(type, this.getUserId, key, commentId)) {
          this.setReadTime({
            itemType: 'comments',
            targetType: type,
            targetOwner: this.getUserId,
            targetId: key,
            itemId: commentId,
            readTime: new Date().getTime()
          })
        }
      }
      if (!this.open) {
        this.open = true
        this.$refs.oneDetailView.openDetailView()
      }
    },
    get1on1UnreadCommentKeys (itemType, itemId, allCommentsIds) {
      let targetComments = this.getCommentsByCommentIdsTargetType(allCommentsIds, itemType)
      for (let i = 0; i < targetComments.length; i++) {
        if (!this.getIsReadComment(itemType, this.getUserId, itemId, targetComments[i].id)) {
          return true
        }
      }
      return false
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.oneCount - 1) {
        this.oneCount += 30
        this.$forceUpdate()
      }
    },
    onClickCloseDetailView () {
      this.open = false
    }
  },
  filters: {
    lessThanHundred: function (unreadCount) {
      return unreadCount > 99 ? 99 : unreadCount
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  .isExistUnread {
    position: relative;
  }
  .isExistUnread span {
    position: absolute;
    width: 15px;
    height: 15px;
    margin-bottom: 5px;
    right: 0;
    top: -5px;
    color: white;
    display: inline-block;
    background-color: rgba(254,64,56,0.9);
    border-color: red;
    border-width: 2px;
    border-radius: 50%;
    line-height: 15px;
    text-align:center;
    vertical-align: middle;
  }
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  } */
  .star {
    width: 2.0rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/one/OneList.vue